import { render, staticRenderFns } from "./PaginaSuccess.vue?vue&type=template&id=95bdff74&scoped=true&"
import script from "./PaginaSuccess.vue?vue&type=script&lang=js&"
export * from "./PaginaSuccess.vue?vue&type=script&lang=js&"
import style0 from "./PaginaSuccess.vue?vue&type=style&index=0&id=95bdff74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bdff74",
  null
  
)

export default component.exports